import React from "react";

function SpiceContent({ item, animation, description }) {
  const { image, imageSrc, imagePosition } = item;
  const animationClass = animation ? "fade-in" : "fade-out";
  return (
    <div className={`content spice-content ${animationClass}`}>
      <div className="spice-image-container">
        <img
          className={`spice-details-image zoom spice-image-${imagePosition}`}
          src={imageSrc}
          alt={image}
          loading="lazy"
        />
      </div>
      <div className="spice-details-text">
        <div className="body-b1">{description}</div>
      </div>
    </div>
  );
}

export default SpiceContent;
